export default {
  dialogTitle: "Edit Canvas",
  canvasName: {
    label: "Canvas Name",
    placeholder: "Please enter canvas name (required)",
  },
  canvasDescription: {
    label: "Canvas Description",
    placeholder: "Please describe the canvas",
  },
  defaultAddress: {
    label: "Default Address",
    placeholder: "Please enter default address",
  },
  buttons: {
    reset: "Reset",
    confirm: "Confirm",
  },
  messages: {
    editSuccess: "Edit successful",
    confirmEditRootNode:
      "Modifying the root node address will reset the existing analysis content of this canvas. Do you want to proceed?",
    confirmTitle: "Confirm",
    confirmButton: "Confirm",
    cancelButton: "Cancel",
    cancelled: "Cancelled",
    ruleMessage: "Case name is required",
  },
};
